<template>
  <div class="container-fluid p-0">
    <div class="row mb-2 mb-xl-3">
      <div class="col-auto d-none d-sm-block">
        <h3 class="laranja h4">{{ $t('label.fichaTecnicaEspecieMMA') }}</h3>
      </div>
    </div>
    <FichasFiltroMMA />
  </div>
</template>

<script>
import FichasFiltroMMA from './FichasFiltroMMA.vue'
export default {
  name: 'FichasMMA',
  components: { FichasFiltroMMA }
}
</script>
